import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { Unidade } from './unidade.model';

@Injectable({
  providedIn: 'root'
})
export class UnidadeService extends DefaultService<Unidade>{

  static url = '/api/estoque/v1/unidades';

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) { 
    super(
      httpClient,
      errorHandler,
      UnidadeService.url
    )

  }
}
